var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('FormTreeSelect',{attrs:{"multiple":true,"options":_vm.options,"value":_vm.value,"value-consists-of":"LEAF_PRIORITY","default-expand-level":1,"limit":1,"limit-text":_vm.limitText,"branch-nodes-first":true,"placeholder":_vm.placeholder},on:{"close":_vm.setValues}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }